import styled from 'styled-components';

import { FlexContainer } from 'styles/layouts';

export const Container = styled(FlexContainer)<{ displayVertical: boolean }>`
  flex-direction: ${({ displayVertical }) =>
    displayVertical ? 'column' : 'row'};
`;
